import { observable } from 'mobx';
import guid from '../../../../utils/guid';
import { User } from '../../../../models';

export default class Annotation {
  @observable date_created;
  @observable text;
  @observable time;

  constructor({
    id = guid(),
    date_created = new Date(),
    text = '',
    time,
    person = {}
  }) {
    this.id = id;
    this.date_created = date_created;
    this.text = text;
    this.time = time;
    this.person = new User(person);
  }
}



// WEBPACK FOOTER //
// ./src/containers/analyse/store/model/Annotation.js